import { Component } from "@angular/core";
import { HeaderComponent } from "@coreui/angular";

@Component({
    selector: 'app-menu',
    templateUrl: './public-menu.component.html',
    styleUrl: './public-menu.component.scss'
})
export class PublicMenuComponent {

    constructor() {
    }

}